import MasonryGrid from '../components/MasonryGrid';
import ProductListItem from '../components/ProductListItem';
import Select from '../components/Select';

export default class StaticCollection {
  constructor(section) {
    this.el = section.el;
    this.collectionTagsEl = this.el.querySelector('[data-collection-tags]');
    this.collectionSortingEl = this.el.querySelector('[data-collection-sorting]');
    this.masonry = this.el.querySelector('[data-masonry-grid]');
    this.masonryGrid = null;

    this.productListItems = [];
    document
      .querySelectorAll('.product-list-item')
      .forEach(product => this.productListItems.push(new ProductListItem({ el: product })));

    if (this.collectionTagsEl) {
      this.collectionTagsEl.addEventListener('change', event => this.filterCollection(event));
      new Select({ el: this.collectionTagsEl });
    }

    if (this.collectionSortingEl) {
      this.collectionSortingEl.addEventListener('change', event => this.sortCollection(event));
      new Select({ el: this.collectionSortingEl });
    }

    if (this.masonry) {
      this.masonryGrid = new MasonryGrid({
        el: this.masonry,
        settings: {
          itemSelector: '.product-list-item',
          horizontalOrder: true,
        },
      });
    }
  }

  onSectionUnload() {
    this.remove();
  }

  remove() {
    if (this.masonryGrid) {
      this.masonryGrid.unload();
    }

    for (let i = 0; i < this.productListItems.length; i++) {
      this.productListItems[i].remove();
    }

    this.collectionTagsEl.removeEventListener('change', event => this.filterCollection(event));
    this.collectionSortingEl.removeEventListener('change', event => this.sortCollection(event));
  }

  filterCollection(event) {
    const { currentTarget } = event;
    const { value: tag, dataset } = currentTarget;
    const { url } = dataset;

    if (tag === 'all') {
      window.location.href = `${window.Theme.routes.collections_url}/${url}`;
    } else {
      window.location.href = `${window.Theme.routes.collections_url}/${url}/${tag}`;
    }
  }

  sortCollection(event) {
    const { currentTarget } = event;
    let search;

    const Sorting = {};
    Sorting.sort_by = currentTarget.value;

    if (currentTarget.closest('.select-wrapper').classList.contains('vendor-collection')) {
      const currentSearch = location.search;
      const searchParts = currentSearch.split('&');

      for (let index = 0; index < searchParts.length; index++) {
        const part = searchParts[index];
        if (part.indexOf('sort_by') !== -1) {
          searchParts.splice(index, 1);
        }
      }

      search = searchParts.join('&');
      location.search = `${search}&${Object.keys(Sorting).map(k => (
        `${encodeURIComponent(k)}=${encodeURIComponent(Sorting[k])}`
      )).join('&')}`;
      return;
    }

    location.search = Object.keys(Sorting).map(k => (
      `${encodeURIComponent(k)}=${encodeURIComponent(Sorting[k])}`
    )).join('&');
  }
}
